import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/rightArrowFilled.svg'
import _imports_1 from '@/assets/downArrow.svg'
import _imports_2 from '@/assets/correctIcon.svg'
import _imports_3 from '@/assets/cancel.svg'
import _imports_4 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "flexcontainer pt-3 px-5" }
const _hoisted_2 = { class: "pagetitle flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Questionnaire")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "w-full flex items-center" }
const _hoisted_7 = { class: "w-2 flex items-center" }
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  class: "h-4 w-4 cursor-pointer"
}
const _hoisted_10 = { class: "heading font-opensans flex justify-between items-center text-sm w-98 pl-1" }
const _hoisted_11 = { class: "mr-1" }
const _hoisted_12 = {
  key: 0,
  class: "rounded-full w-5 h-5 bg-green mx-auto"
}
const _hoisted_13 = {
  key: 1,
  class: "rounded-full w-5 h-5 bg-error mx-auto"
}
const _hoisted_14 = {
  key: 0,
  class: "accordion-body bg-white"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", { class: "border-t-2" }, null, -1)
const _hoisted_16 = ["onChange"]
const _hoisted_17 = { class: "p-2.5" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-xs mb-2 fontFamily-roboto" }, "Question Name", -1)
const _hoisted_21 = ["onUpdate:modelValue", "onInput"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 text-xs" }, "Limit exceeded", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_29 = { class: "flex justify-end items-end pl-6" }
const _hoisted_30 = { class: "switch" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_33 = { class: "mt-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-xs mb-2 fontFamily-roboto" }, "Select Screen", -1)
const _hoisted_35 = ["onUpdate:modelValue", "disabled"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  hidden: "",
  disabled: ""
}, "Please select question type", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", null, "RadioQuestionType", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", null, "ChecBoxQuestionType", -1)
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_42 = { class: "formgroup mt-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-xs mb-2 fontFamily-roboto" }, "Enter the Question", -1)
const _hoisted_44 = ["onUpdate:modelValue", "onInput"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 text-xs" }, "Limit Exceeded", -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_50 = {
  key: 0,
  class: "radioblock"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "optionsblock mt-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold mb-2 text-sm fontFamily-roboto" }, "Enter the option")
], -1)
const _hoisted_52 = { class: "optionsblock card mt-2" }
const _hoisted_53 = { class: "imgoptioncontainer flex" }
const _hoisted_54 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "ml-2" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = {
  key: 0,
  class: "text-red-500 mt-1"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "error-text" }, "At least 2 options are required.", -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "text-black no-underline mt-6 min-h-30" }
const _hoisted_68 = { class: "accordion-body white p-5" }
const _hoisted_69 = { class: "formgroup mb-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-sm fontFamily-roboto" }, "Enter Option", -1)
const _hoisted_71 = {
  key: 0,
  class: "text-red-500 mt-1"
}
const _hoisted_72 = {
  key: 0,
  class: "error-text"
}
const _hoisted_73 = {
  key: 1,
  class: "text-red-500 mt-1"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "error-text" }, "Limit Exceeded", -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "formgroup mt-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-sm fontFamily-roboto" }, "Enter Option Description", -1)
const _hoisted_78 = ["onUpdate:modelValue"]
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { class: "formgroup mt-2" }
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "validateoption ml-3" }, "If right please check", -1)
const _hoisted_83 = { class: "buttonposition flex items-center justify-center my-1.5 mx-0" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = {
  key: 1,
  class: "textboxblock"
}
const _hoisted_86 = { class: "formgroup" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-sm mb-1 fontFamily-roboto" }, "Enter the Text", -1)
const _hoisted_88 = ["onUpdate:modelValue"]
const _hoisted_89 = { class: "formgroup" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-sm mb-1 fontFamily-roboto" }, "Enter Option Description", -1)
const _hoisted_91 = ["onUpdate:modelValue"]
const _hoisted_92 = {
  key: 2,
  class: "checkboxblock"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "optionsblock mt-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold mb-2 text-xs fontFamily-roboto" }, "Enter the option")
], -1)
const _hoisted_94 = { class: "optionsblock card mt-2" }
const _hoisted_95 = { class: "imgoptioncontainer flex" }
const _hoisted_96 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = { class: "ml-2" }
const _hoisted_103 = ["onClick"]
const _hoisted_104 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = {
  key: 0,
  class: "text-red-500 mt-1"
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "error-text" }, "At least 2 options are required.", -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = { class: "text-black no-underline mt-6 min-h-30" }
const _hoisted_110 = { class: "accordion-body white p-5" }
const _hoisted_111 = { class: "formgroup mb-2" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-sm mb-1 fontFamily-roboto" }, "Enter Option", -1)
const _hoisted_113 = {
  key: 0,
  class: "text-red-500 mt-1"
}
const _hoisted_114 = {
  key: 0,
  class: "error-text"
}
const _hoisted_115 = {
  key: 1,
  class: "text-red-500 mt-1"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "error-text" }, "Limit Exceeded", -1)
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = { class: "formgroup mt-3" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-semibold text-sm mb-1 fontFamily-roboto" }, "Enter Option Description", -1)
const _hoisted_120 = ["onUpdate:modelValue"]
const _hoisted_121 = { class: "formgroup mt-2" }
const _hoisted_122 = ["onUpdate:modelValue"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("span", { class: "validateoption ml-2.5" }, "If right please check", -1)
const _hoisted_124 = { class: "buttonposition flex items-center justify-center my-1.5 mx-0" }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = { class: "p-4" }
const _hoisted_127 = { class: "flex justify-center" }
const _hoisted_128 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_129 = ["onClick"]
const _hoisted_130 = {
  key: 1,
  class: "buttonposition flex justify-center items-center"
}
const _hoisted_131 = ["onClick"]
const _hoisted_132 = {
  key: 2,
  class: "buttonposition flex justify-center items-center ml-6"
}
const _hoisted_133 = ["onClick"]
const _hoisted_134 = {
  key: 3,
  class: "flex justify-center items-center ml-6"
}
const _hoisted_135 = ["onClick"]
const _hoisted_136 = {
  key: 1,
  class: "text-center flex justify-center items-center text-sm mt-8 text-black"
}
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", null, "No Questions. Please start adding by clicking on Add button on top.", -1)
const _hoisted_138 = [
  _hoisted_137
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btnprimary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addquestions()))
        }, "Add Questions")
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.questionaire.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionaire, (singlequestion, moduleIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["text-black no-underline mt-3 min-h-30 cursor-pointer rounded", { accordion: singlequestion.isActive }]),
                key: singlequestion.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex bg-white py-2.5 px-2.5 font-opensans text-sm w-full rounded", { 'accordion-head': !singlequestion.isActive }]),
                  onClick: ($event: any) => (_ctx.questionSelect(singlequestion,moduleIndex))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (!singlequestion.isActive)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : (_openBlock(), _createElementBlock("img", _hoisted_9))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, _toDisplayString(singlequestion.questionaireName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.questionaire[moduleIndex].isScreenActive == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13))
                  ])
                ], 10, _hoisted_5),
                (singlequestion.isActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("form", {
                        onChange: ($event: any) => (_ctx.changedInputControlValue(singlequestion))
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["inputboxstyling mt-2", {
								'error-border': _ctx.displayErrorMessage ||(singlequestion.validationScreenName && _ctx.validCode == singlequestion.questionaireName)||singlequestion.questionaireName==''
							}]),
                                placeholder: "Question Name",
                                "onUpdate:modelValue": ($event: any) => ((singlequestion.questionaireName) = $event),
                                onInput: ($event: any) => (_ctx.isNameTooLong(singlequestion))
                              }, null, 42, _hoisted_21), [
                                [_vModelText, singlequestion.questionaireName]
                              ]),
                              (singlequestion.validationScreenName && _ctx.validCode == singlequestion.questionaireName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (singlequestion.validationScreenName && _ctx.validCode == singlequestion.questionaireName)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Question Name Already Exist"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.displayErrorMessage)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                                  : (_ctx.v$.questionaire.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        ((!_ctx.v$.questionaire.$each.$response.$data[moduleIndex].questionaireName.required))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("label", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.questionaire[moduleIndex].isScreenActive) = $event)
                                }, null, 8, _hoisted_31), [
                                  [_vModelCheckbox, _ctx.questionaire[moduleIndex].isScreenActive]
                                ]),
                                _hoisted_32
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _withDirectives(_createElementVNode("select", {
                              class: _normalizeClass(["inputboxstyling mt-2", {
							'error-border': (_ctx.v$.questionaire.$error&&(!_ctx.v$.questionaire.$each.$response.$data[moduleIndex].questionaireType.required)),'inputboxstylingForSelectAtPopup': singlequestion.questionaireType === '','stylingForInputboxstylingForSelectAtPopup': singlequestion.questionaireType !== '' 
						}]),
                              "onUpdate:modelValue": ($event: any) => ((singlequestion.questionaireType) = $event),
                              disabled: singlequestion._id
                            }, _hoisted_39, 10, _hoisted_35), [
                              [_vModelSelect, singlequestion.questionaireType]
                            ]),
                            (_ctx.v$.questionaire.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  ((!_ctx.v$.questionaire.$each.$response.$data[moduleIndex].questionaireType.required))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["inputboxstyling mt-2", {
							'error-border': (_ctx.v$.questionaire.$error && (!_ctx.v$.questionaire.$each.$response.$data[moduleIndex].question.required || !_ctx.v$.questionaire.$each.$response.$data[moduleIndex].question.questionLimit)||_ctx.displayErrorMessageforQuestion)
						}]),
                              placeholder: "Question",
                              "onUpdate:modelValue": ($event: any) => ((singlequestion.question) = $event),
                              onInput: ($event: any) => (_ctx.isNameTooLong(singlequestion))
                            }, null, 42, _hoisted_44), [
                              [_vModelText, singlequestion.question]
                            ]),
                            (_ctx.displayErrorMessageforQuestion)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                              : (_ctx.v$.questionaire.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    ((!_ctx.v$.questionaire.$each.$response.$data[moduleIndex].question.required))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                          ]),
                          (singlequestion.questionaireType == 'RadioQuestionType')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("div", null, [
                                  _hoisted_51,
                                  _createElementVNode("div", _hoisted_52, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlequestion.options, (singleoption, optionIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: singleoption.id,
                                        class: "px-2"
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["accordion-head mt-3 p-1.5 text-black flex justify-between bg-white min-h-30", {
													'error-border p-1': singlequestion.options.length < 2
												}])
                                        }, [
                                          _createElementVNode("div", _hoisted_53, [
                                            (singleoption.correct)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59)),
                                            _createElementVNode("div", _hoisted_60, _toDisplayString(singleoption.text), 1)
                                          ]),
                                          _createElementVNode("div", {
                                            onClick: ($event: any) => (_ctx.onradioDelete(optionIndex, moduleIndex))
                                          }, _hoisted_63, 8, _hoisted_61)
                                        ], 2),
                                        (singlequestion.options.length < 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_66))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _createElementVNode("div", _hoisted_69, [
                                          _hoisted_70,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: _normalizeClass(["inputboxstyling mt-2", {
											'error-border p-1': (_ctx.v$.singlequestionObj.$error && _ctx.v$.singlequestionObj.optionsvalue && singlequestion.options.length < 2) || (_ctx.singlequestionObj.optionsvalue != undefined && _ctx.singlequestionObj.optionsvalue.length > 100)
										}]),
                                            placeholder: "Name of the Option",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.singlequestionObj.optionsvalue) = $event))
                                          }, null, 2), [
                                            [_vModelText, _ctx.singlequestionObj.optionsvalue]
                                          ]),
                                          (_ctx.v$.singlequestionObj.$error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                (_ctx.v$.singlequestionObj.optionsvalue && singlequestion.options.length < 2)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, "Required"))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.singlequestionObj.optionsvalue != undefined && _ctx.singlequestionObj.optionsvalue.length > 100)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_76, [
                                          _hoisted_77,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "inputboxstyling mt-2",
                                            placeholder: "If option is right why or wrong why",
                                            "onUpdate:modelValue": ($event: any) => ((singlequestion.optiondescription) = $event)
                                          }, null, 8, _hoisted_78), [
                                            [_vModelText, singlequestion.optiondescription]
                                          ])
                                        ]),
                                        (_ctx.questionaire[moduleIndex].answerVisibility || _ctx.optionsCount == 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                              _createElementVNode("div", _hoisted_80, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "checkbox",
                                                  "onUpdate:modelValue": ($event: any) => ((singlequestion.correctAnswer) = $event)
                                                }, null, 8, _hoisted_81), [
                                                  [_vModelCheckbox, singlequestion.correctAnswer]
                                                ]),
                                                _hoisted_82
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_83, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: _normalizeClass([_ctx.singlequestionObj.optionsvalue == '' || _ctx.singlequestionObj.optionsvalue == undefined || _ctx.singlequestionObj.optionsvalue.length > 100 || (singlequestion.options.length == 5 || singlequestion.options.length > 5)?'btndisabled pointer-events-none':'btnprimary', "m-2.5"]),
                                          onClick: ($event: any) => (_ctx.questionRadioScreen(moduleIndex))
                                        }, "Add", 10, _hoisted_84)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (singlequestion.questionaireType == 'TextBoxQuestionType')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                _createElementVNode("div", _hoisted_86, [
                                  _hoisted_87,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "inputboxstyling",
                                    placeholder: "",
                                    "onUpdate:modelValue": ($event: any) => ((singlequestion.answer) = $event)
                                  }, null, 8, _hoisted_88), [
                                    [_vModelText, singlequestion.answer]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_89, [
                                  _hoisted_90,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "inputboxstyling",
                                    placeholder: "If it is right why or wrong why",
                                    "onUpdate:modelValue": ($event: any) => ((singlequestion.answerDescription) = $event)
                                  }, null, 8, _hoisted_91), [
                                    [_vModelText, singlequestion.answerDescription]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (singlequestion.questionaireType == 'ChecBoxQuestionType')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                _createElementVNode("div", null, [
                                  _hoisted_93,
                                  _createElementVNode("div", _hoisted_94, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singlequestion.options, (singleoption, optionIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: singleoption.id,
                                        class: "px-2"
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["accordion-head mt-3 p-1.5 text-black flex justify-between bg-white min-h-30", {
														'error-border p-1': singlequestion.options.length < 2
													}])
                                        }, [
                                          _createElementVNode("div", _hoisted_95, [
                                            (singleoption.correct)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, _hoisted_98))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_99, _hoisted_101)),
                                            _createElementVNode("div", _hoisted_102, _toDisplayString(singleoption.text), 1)
                                          ]),
                                          _createElementVNode("div", {
                                            onClick: ($event: any) => (_ctx.oncheckBoxDelete(optionIndex, moduleIndex))
                                          }, _hoisted_105, 8, _hoisted_103)
                                        ], 2),
                                        (singlequestion.options.length < 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, _hoisted_108))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createElementVNode("div", _hoisted_109, [
                                      _createElementVNode("div", _hoisted_110, [
                                        _createElementVNode("div", _hoisted_111, [
                                          _hoisted_112,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: _normalizeClass(["inputboxstyling mt-2", {
											'error-border p-1': (_ctx.v$.singlequestionObj.$error && _ctx.v$.singlequestionObj.optionsvalue && singlequestion.options.length < 2) || (_ctx.singlequestionObj.optionsvalue != undefined && _ctx.singlequestionObj.optionsvalue.length > 100)
										}]),
                                            placeholder: "Name of the Option",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.singlequestionObj.optionsvalue) = $event))
                                          }, null, 2), [
                                            [_vModelText, _ctx.singlequestionObj.optionsvalue]
                                          ]),
                                          (_ctx.v$.singlequestionObj.$error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                                (_ctx.v$.singlequestionObj.optionsvalue && singlequestion.options.length < 2)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, "Required"))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.singlequestionObj.optionsvalue != undefined && _ctx.singlequestionObj.optionsvalue.length > 100)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_115, _hoisted_117))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_118, [
                                          _hoisted_119,
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "inputboxstyling mt-2",
                                            placeholder: "If option is right why or wrong why",
                                            "onUpdate:modelValue": ($event: any) => ((singlequestion.optiondescription) = $event)
                                          }, null, 8, _hoisted_120), [
                                            [_vModelText, singlequestion.optiondescription]
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_121, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              class: "checkbox",
                                              "onUpdate:modelValue": ($event: any) => ((singlequestion.correctAnswer) = $event)
                                            }, null, 8, _hoisted_122), [
                                              [_vModelCheckbox, singlequestion.correctAnswer]
                                            ]),
                                            _hoisted_123
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_124, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: _normalizeClass([_ctx.singlequestionObj.optionsvalue == '' || _ctx.singlequestionObj.optionsvalue == undefined || _ctx.singlequestionObj.optionsvalue.length > 100 || (singlequestion.options.length == 5 || singlequestion.options.length > 5)?'btndisabled pointer-events-none':'btnprimary', "m-2.5"]),
                                          onClick: ($event: any) => (_ctx.questionRadioScreen(moduleIndex))
                                        }, "Add", 10, _hoisted_125)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("div", _hoisted_127, [
                            (singlequestion._id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(JSON.stringify(singlequestion)!==JSON.stringify(_ctx.dummyQuestionaire)? 'btnprimary':'btndisabled pointer-events-none'),
                                    onClick: ($event: any) => (_ctx.resetData(singlequestion,moduleIndex))
                                  }, "Reset", 10, _hoisted_129)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass([JSON.stringify(singlequestion)!==JSON.stringify(_ctx.dummyQuestionaire)? 'btnprimary':'btndisabled pointer-events-none', "btnprimary"]),
                                    onClick: ($event: any) => (_ctx.resetData(singlequestion))
                                  }, "Reset", 10, _hoisted_131)
                                ])),
                            (singlequestion._id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(singlequestion._id && (JSON.stringify(singlequestion)!==JSON.stringify(_ctx.dummyQuestionaire)) ?  'btnprimary' : 'btndisabled pointer-events-none'),
                                    onClick: ($event: any) => (_ctx.createPayload(moduleIndex))
                                  }, "Update", 10, _hoisted_133)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(JSON.stringify(_ctx.dummyQuestionaire)!==JSON.stringify(singlequestion) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                    onClick: ($event: any) => (_ctx.createPayload(moduleIndex))
                                  }, "Save", 10, _hoisted_135)
                                ]))
                          ])
                        ])
                      ], 40, _hoisted_16)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_136, _hoisted_138))
    ])
  ]))
}